import React from "react";

function DownArrow() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="12.222"
      viewBox="0 0 20 12.222"
    >
      <path
        id="Path_19901"
        data-name="Path 19901"
        d="M15.636,16l7.778-7.778,2.222,2.222-10,10-10-10L7.858,8.222Z"
        transform="translate(-5.636 -8.222)"
        fill="#596970"
      />
    </svg>
  );
}

export default DownArrow;
